import React from "react"
import clsx from "clsx"
import { Link } from "gatsby"
import useDarkMode from "use-dark-mode"

export const PostEntryTitle = ({
  post,
  location,
  className = "",
  ...props
}) => {
  const { title, uri } = post

  const isDarkMode = useDarkMode().value

  return (
    <>
      {location === "single" ? (
        <h1
          dangerouslySetInnerHTML={{ __html: title }}
          className={clsx(className)}
          style={
            isDarkMode
              ? {
                  backgroundImage:
                    "linear-gradient(-90deg,#adfbda 0,#35c3ff 30%,#fda399 50%,#76d880 70%,#ebf38b 90%,#adfbda 100%)",
                  backgroundSize: "100%",
                  backgroundRepeat: "repeat",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  MozBackgroundClip: "text",
                  MozTextFillColor: "transparent",
                  filter: "drop-shadow(0 0 2rem #000)",
                  textShadow: "none!important",
                }
              : {}
          }
          {...props}
        />
      ) : (
        <h2 className={`text-3xl ${className}`} {...props}>
          <Link
            to={`${uri}`}
            dangerouslySetInnerHTML={{ __html: title }}
            className={`hover:underline`}
          />
        </h2>
      )}
    </>
  )
}
